import { render, staticRenderFns } from "./SetPasswordHeader.vue?vue&type=template&id=cd319f3c&scoped=true"
import script from "./SetPasswordHeader.vue?vue&type=script&lang=js"
export * from "./SetPasswordHeader.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordHeader.vue?vue&type=style&index=0&id=cd319f3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd319f3c",
  null
  
)

export default component.exports